import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import logo from '../../public/static/images/logo.png';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import { ITUNES_APP_URL } from '../../constants';
import { useTrackingContext } from '../../hooks';

const Navbar = ({ isHomepage = false }) => {
  const router = useRouter();
  const { trackExternalLink, trackInternalLink } = useTrackingContext();
  const isDiscoverPage = router.pathname.startsWith('/discover');

  const commonTrackingData = {
    unit_type: 'nav',
    unit_name: 'main',
    item_type: 'link',
  };

  const smoothScrollToSection = (e, id, hash) => {
    e.preventDefault();

    const section = document.getElementById(id);

    if (!section) return;

    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.location.hash !== hash) {
      window.history.replaceState(null, '', hash);
    }
  };

  const handleGetIslandClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    trackExternalLink({
      ...commonTrackingData,
      item_type: 'button',
      item_name: 'get_island',
      position_in_unit: 1,
      target_content_url: ITUNES_APP_URL,
    });

    window.open(`${ITUNES_APP_URL}?pt=329394&ct=bfidc_nav&mt=8`, '_blank', 'noopener,noreferrer');
  };

  const handleTryGeneratorsClick = () => {
    trackInternalLink({
      ...commonTrackingData,
      item_name: 'try_generators',
      position_in_unit: isHomepage ? 2 : 1,
      target_content_type: 'utility',
      target_content_id: 'discover',
    });
  };

  const handleFaqClick = (e) => {
    trackInternalLink({
      ...commonTrackingData,
      item_name: 'faq',
      position_in_unit: isHomepage ? 3 : 2,
      target_content_type: 'utility',
      target_content_id: 'faq',
    });

    if (document.getElementById('faq')) {
      smoothScrollToSection(e, 'faq', '#faq');
    }
  };

  const handleLearnMoreClick = (e) => {
    trackInternalLink({
      ...commonTrackingData,
      item_name: 'learn_more',
      position_in_unit: 1,
      target_content_type: 'utility',
      target_content_id: 'get_ready_to_explore',
    });

    smoothScrollToSection(e, 'get-ready-to-explore', '#get-ready-to-explore');
  };

  const handleLogoClick = () => {
    if (!isHomepage) {
      trackInternalLink({
        ...commonTrackingData,
        item_name: 'home',
        position_in_unit: 0,
        target_content_type: 'utility',
        target_content_id: 'home',
      });

      // Navigate to homepage
      router.push('/');
    }
  };

  return (
    <div className={styles.navbar} role="banner">
      <div className={styles.logoWrapper} onClick={handleLogoClick}>
        <img className={styles.logo} src={logo} alt="Island logo" />
      </div>
      <nav className={styles.navLinks} aria-label="Primary">
        {isHomepage && (
          <a href="#get-ready-to-explore" className={styles.navLink} onClick={handleLearnMoreClick}>
            Learn more
          </a>
        )}
        {isDiscoverPage ? (
          <span className={`${styles.navLink} ${styles.navLinkActive}`} aria-current="page">
            Try our generators
          </span>
        ) : (
          <Link href="/discover">
            <a className={styles.navLink} onClick={handleTryGeneratorsClick}>Try our generators</a>
          </Link>
        )}
        <a href="#faq" className={styles.navLink} onClick={handleFaqClick}>FAQ</a>
      </nav>
      <BFIslandButton
        className={styles.button}
        onClick={handleGetIslandClick}
        text="Get island"
        size="small"
        responsive
        bgColor={BFIslandColors.LIME}
      />
    </div>
  );
};

export default Navbar;
